// components/item/Item.tsx
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import { CatUploadInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import search from '../../../../../assets/images/icons/search.svg'
import { format } from 'date-fns'
import { useSelector } from 'react-redux'
import { CatUploadStatus } from '../../../../../common/types/enums'

type Props = {
  startEdit: (el: CatUploadInterface) => void
  el: CatUploadInterface
  showDetails: (el: CatUploadInterface) => void
}

const getStatusText = (status: CatUploadStatus): string => {
  const map: Record<string, string> = {
    [CatUploadStatus.PENDING]: 'Ожидает',
    [CatUploadStatus.PROCESSING]: 'В обработке',
    [CatUploadStatus.SUCCESS]: 'Успешно',
    [CatUploadStatus.ERROR]: 'Ошибка',
  }
  return map[status] || 'Неизвестно'
}

const getStatusColor = (status: CatUploadStatus): string => {
  const map: Record<string, string> = {
    [CatUploadStatus.PENDING]: '#f39c12',
    [CatUploadStatus.PROCESSING]: '#3498db',
    [CatUploadStatus.SUCCESS]: '#2ecc71',
    [CatUploadStatus.ERROR]: '#e74c3c',
  }
  return map[status] || '#95a5a6'
}

export const Item = ({ startEdit, el, showDetails }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div
      className={darkTheme ? classes.containerDark : classes.container}
      style={{
        filter: el.status === CatUploadStatus.ERROR ? 'opacity(0.7)' : 'opacity(1)',
      }}
    >
      <div className={classes.contentContainer}>
        <div className={classes.id}>
          <div className={classes.label}>id</div>
          <div className={classes.value}>{el.id}</div>
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Файл</div>
          <div className={classes.value}>{el.fileName}</div>
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Статус</div>
          <div className={classes.value} style={{ color: getStatusColor(el.status) }}>
            {getStatusText(el.status)}
          </div>
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Категорий</div>
          <div className={classes.value}>{el.categoriesImported || 0}</div>
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Товаров</div>
          <div className={classes.value}>{el.itemsImported || 0}</div>
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Картинок</div>
          <div className={classes.value}>{el.imagesImported || 0}</div>
        </div>
        {el.importedAt && (
          <div className={classes.date}>
            <div className={classes.label}>Импортирован</div>
            <div className={classes.value}>
              {format(new Date(el.importedAt), 'dd.MM.yyy HH:mm')}
            </div>
          </div>
        )}
        {el.errorMessage && (
          <div className={classes.item}>
            <div className={classes.label}>Ошибка</div>
            <div className={classes.value} style={{ color: '#e74c3c', fontSize: '10px' }}>
              {el.errorMessage}
            </div>
          </div>
        )}
      </div>

      <div className={classes.buttons}>
        <IconButton display onClick={() => showDetails(el)} icon={search} alt="Детали" small />

      </div>
    </div>
  )
}
